import React from "react";
import ScrollAnimation from "react-animate-on-scroll";
import SectionTitle from "../components/sectionTitle/SectionTitle";
import FooterOne from "../common/footer/FooterOne";
import BreadcrumbOne from "../common/breadcrumb/BreadcrumbOne";
import Layout from "../common/Layout";
import SEO from "../common/SEO";
import { useTranslation } from 'react-i18next';

const Profile = (props) => {
    const { t } = useTranslation();
    const isHomePage = window.location.pathname === "/";

    // Localized section titles and descriptions
    const sections = t('profile.sections', { returnObjects: true }) || [];

    // Static assets and layout flags remain language‑independent
    const images = [
        "https://images.happysolutions.hu/Beszerze%CC%81s-Modul.png",
        "https://images.happysolutions.hu/happy-trade-hero.jpg",
        "https://images.happysolutions.hu/pe%CC%81nzu%CC%88gyi-modul.jpg",
        "https://images.happysolutions.hu/raktar-es-logisztika.jpg",
        "https://images.happysolutions.hu/csaj-helyett-crm-hez.jpg",
        "https://images.happysolutions.hu/elso-kep-a-fiatal-srac%20helyett.jpg"
    ];

    const reversed = [false, true, false, true, false, true];

    // Build data with safe ids (slugs) while allowing rich HTML titles
    const stripTags = (html = '') => html.replace(/<[^>]*>/g, '').trim();
    const slugify = (text = '') => stripTags(text)
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9\-áéíóöőúüű]/g, '')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');

    const data = sections.map((s, i) => {
        const titleHtml = s.title || '';
        const id = slugify(titleHtml || `sec-${i}`) || `sec-${i}`;
        return ({
            id,
            titleHtml,
            titleText: stripTags(titleHtml),
            description: s.description,
            img: images[i],
            reversed: reversed[i] || false,
            items: s.items || [],
            bottomText: s.bottomText || ''
        });
    });

    const handleClick = (event, id) => {
        event.preventDefault();
        const element = document.getElementById(id);
        if (element) {
            const offsetPosition = element.offsetTop; // Change 100 to your desired offset
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
            //window.location.hash = `#${title}`;
        }
    };

    return (
        <Layout>
            {!isHomePage && <SEO title={t('profile.seoTitle')}/>}
            {false && <BreadcrumbOne
                style={{backgroundImage: `url('https://happy-releases.fra1.cdn.digitaloceanspaces.com/Uploads/HappyWeb/images/delivery-module-banner.jpg')`}}
                title={t('profile.breadcrumbTitle')}
                rootUrl="/"
                parentUrl={t('profile.breadcrumbParent')}
            />}

            <div className="edu-about-area about-style-3 bg-image">
                <div className="edu-breadcrumb-area breadcrumb-style-1 ptb--60 ptb_md--40 ptb_sm--40 bg-image">
                    <div className="container eduvibe-animated-shape d-flex" style={{flexWrap: 'wrap', gap: '1.5rem'}}>
                        {data.map(item => {
                            return (
                                <div className="breadcrumb-inner text-start d-flex" key={item.id}>
                                    <i className="ri-arrow-drop-right-line"></i>
                                    <div className="page-title">
                                        <span className="title" style={{whiteSpace: 'nowrap'}}
                                           onClick={(event)=>{handleClick(event, item.id)}}
                                           dangerouslySetInnerHTML={{__html: item.titleHtml}}></span>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
                <div className="container eduvibe-animated-shape">
                    {data.map(row => {
                        return (
                            <div className="row g-5" id={row.id}
                                 style={{flexDirection: !row.reversed ? "row" : "row-reverse", alignItems: 'center'}}>
                                <div className="col-lg-6" id={"delivery-module"}>
                                    <div className="inner">
                                        <SectionTitle
                                            classes="text-start"
                                            title={row.titleHtml}
                                        />
                                        <ScrollAnimation
                                            animateIn="fadeInUp"
                                            animateOut="fadeInOut"
                                            animateOnce={true}
                                        >
                                        <p className="description mt--40"
                                            dangerouslySetInnerHTML={{__html: row.description}}
                                        />
                                        </ScrollAnimation>
                                        <div className="row g-5" style={{margin: '2rem'}}>
                                            <div className="d-flex flex-column gap-2">
                                                {row.items.map((b, i) => (
                                                    <div key={`benefit-card-${i}`} className="d-flex align-items-center">
                                                        <div className="content">
                                                            <div className="title d-flex align-items-center">
                                                                <i
                                                                    className="fas fa-check-square"
                                                                    aria-hidden="true"
                                                                    style={{ color: "rgb(247, 140, 69)", marginRight: "6px" }}
                                                                ></i>
                                                                {b.text}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        <p className="description mt--40"
                                           dangerouslySetInnerHTML={{__html: row.bottomText || ''}}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-6" id={"delivery-module"}>
                                    <div className="inner">
                                        <ScrollAnimation
                                            animateIn="fadeIn"
                                            animateOut="fadeInOut"
                                            className="testimonial-left-image"
                                            animateOnce={true}
                                            style={{margin: '5rem 0'}}
                                        >
                                            <div className="thumbnail">
                                                <div className="circle-image-wrapper" style={{width: "48rem"}}>
                                                    <img
                                                        style={{width: '50rem', height: "44rem", objectFit: 'cover'}}
                                                        className="radius-round"
                                                        src={row.img}
                                                        alt={t('profile.imageAlt')}/>
                                                    <div className="circle-image">
                                                        <span></span>
                                                        <span></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </ScrollAnimation>
                                    </div>
                                </div>
                            </div>
                        )
                    })}

                    <div className="shape-dot-wrapper shape-wrapper d-xl-block d-none">
                        <div className="shape-image shape-image-1">
                            <img src="/images/shapes/shape-21.png" alt="Shape Thumb"/>
                        </div>
                        <div className="shape-image shape-image-2">
                            <img src="/images/shapes/shape-13-04.png" alt="Shape Thumb"/>
                        </div>
                        <div className="shape-image shape-image-3">
                            <img src="/images/shapes/shape-03-05.png" alt="Shape Thumb"/>
                        </div>
                        <div className="shape-image shape-image-4">
                            <img src="/images/shapes/shape-15-02.png" alt="Shape Thumb"/>
                        </div>
                    </div>
                </div>
            </div>
            {!isHomePage && <FooterOne/>}
        </Layout>
    );
};

export default Profile;
